import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Platform, PopoverController} from '@ionic/angular';
import {NativeAudio} from "@capgo/native-audio";
import {PostModel} from 'src/app/models/post.model';
import {PostService} from 'src/app/services/post/post.service';
import {ApiResponse} from 'src/app/services/utils';
import {StorageService} from '../../services/storage/storage.service';
import {AuthService} from "../../services/auth/auth.service";
import {AnonymousService} from "../../services/anonymous/anonymous.service";
import {Capacitor} from "@capacitor/core";

@Component({
    selector: 'app-set-rating',
    templateUrl: './set-rating.component.html',
    styleUrls: ['./set-rating.component.scss'],
    standalone: false
})
export class SetRatingComponent implements OnInit, AfterViewInit {
  @ViewChild('rangeElement', {static: false, read: ElementRef}) rangeElementRef: ElementRef;
  @Input() item: PostModel;
  @Output() ratingEvent = new EventEmitter<any>();
  isRatingDisabled = false;

  rating = 0;
  colorOfEarth: string;
  gradient = [[0,
    [255, 142, 20]
  ], [50,
    [255, 227, 56]
  ], [100,
    [194, 214, 26]
  ]];

  constructor(
    private postService: PostService,
    private storage: StorageService,
    private auth: AuthService,
    private anonymousService: AnonymousService,
    private popoverController: PopoverController
  ) {
  }

  ngOnInit() {
    this.rating = this.item?.starGiven;
    this.setColorOfRatingButton(this.rating);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const barWidth = this.rangeElementRef.nativeElement.offsetWidth - 40 - 40;
      document.documentElement.style
        .setProperty('--bar-width', `${barWidth}px`);
    }, 100);
  }

  async setRating(val) {
    //this.ratingEvent.emit({isRatingDisabled: false, popupClose: false, item: {}});
    const data = {postId: this.item?.id, star: val};
    this.item.starGiven = val;
    if (Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
      if (val <= 2) {
        NativeAudio.play({
          assetId: 'impact2',
          time: 0
        });
      } else {
        NativeAudio.play({
          assetId: 'impact',
          time: 0
        });
      }
      this.isRatingDisabled = false;
    }

    if (this.auth.isAuthenticated) {
      this.postService.apiAddRating(data).subscribe((result: ApiResponse) => {
        if (result.status) {
          this.item = result.data;
          this.postService.postEvent.next(this.item);
          this.ratingEvent.emit({isRatingDisabled: false, popupClose: true, item: result.data});
          this.popoverController.dismiss({ rating: { item: this.item } }, 'confirm');
        }
      });
    } else {
      this.anonymousService.apiAddRatingAnonymous(data).subscribe((result: ApiResponse) => {
        if (result.status) {
          this.item = result.data;
          this.postService.postEvent.next(this.item);
          this.ratingEvent.emit({isRatingDisabled: false, popupClose: true, item: result.data});
          this.popoverController.dismiss({ rating: { item: this.item } }, 'confirm');
        }
      });
    }
  }

  onIonChange(event) {
    this.rating = event.target.value;
    this.setColorOfRatingButton(this.rating);
  }

  setFinalRating() {
    this.setRating(this.rating);
  }


  setColorOfRatingButton(starsAvg) {
    //Select Color for Item
    let colorRange = [];
    if (starsAvg === undefined) {
      this.colorOfEarth = 'rgb(255, 142, 20)';
    } else if (starsAvg < 50) {
      colorRange = [0, 1];
    } else {
      colorRange = [1, 2];
    }


    if (starsAvg !== undefined) {
      const colRangeFirst = colorRange[0];
      //Get the two closest colors
      const firstColor = this.gradient[colRangeFirst][1];
      const secondColor = this.gradient[colorRange[1]][1];
      //Calculate ratio between the two closest colors
      const gradOne = Number(this.gradient[colorRange[0]][0]);
      const gradTwo = Number(this.gradient[colorRange[1]][0]);
      const firstColor_x = 100 * (gradOne / 100);
      const secondColor_x = 100 * (gradTwo / 100) - firstColor_x;
      const slider_x = 100 * (starsAvg / 100) - firstColor_x;
      const ratio = slider_x / secondColor_x;

      const w = ratio * 2 - 1;
      const w1 = (w / 1 + 1) / 2;
      const w2 = 1 - w1;

      this.colorOfEarth = 'rgb(' + Math.round(secondColor[0] * w1 + firstColor[0] * w2) + ',' +
        Math.round(secondColor[1] * w1 + firstColor[1] * w2) + ',' +
        Math.round(secondColor[2] * w1 + firstColor[2] * w2) + ')';
    }
  }
}
